import {
    LoginCardLayout,
    LoginPageContent,
    MobileLoginLayout,
} from '../../components';
import { useAppDispatch, useTheme } from '../../base';
import { useMediaQuery } from '@mui/material';
import { userActions } from '../../actions';
import { useEffect } from 'react';
import { useLocale } from '../../hooks';
import { LANGUAGES } from '../../common';

const LoginPage = () => {
    const dispatch = useAppDispatch();
    const { language } = useLocale();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        if (
            language.toUpperCase() === LANGUAGES.HE ||
            language.toUpperCase() === LANGUAGES.EN
        ) {
            dispatch(
                userActions.updateLanguage({ language: language.toUpperCase() })
            );
        }
    }, [dispatch, language]);

    const LayoutComponent = isMobile ? MobileLoginLayout : LoginCardLayout;

    return (
        <LayoutComponent>
            <LoginPageContent isMobile={isMobile} />
        </LayoutComponent>
    );
};

export default LoginPage;
